/* global Word console Office */

export async function getCurrentDocumentPath(): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    try {
      Office.onReady(() => {
        Office.context.document.getFilePropertiesAsync((result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            resolve(result.value.url);
          }
        });
      });
    } catch (error) {
      reject(error);
    }
  });
}

export async function insertText(text: string) {
  // Write text to the document.
  try {
    await Word.run(async (context) => {
      let body = context.document.body;
      body.insertParagraph(text, Word.InsertLocation.end);
      await context.sync();
    });
  } catch (error) {
    console.log("Error: " + error);
  }
}

export async function getSelectedText(): Promise<string> {
  try {
    return await Word.run(async (context) => {
      const selection = context.document.getSelection();
      selection.load("text");
      await context.sync();
      return selection.text;
    });
  } catch (error) {
    console.error("Error getting selected text from document:", error);
    return "";
  }
}

/**
 * Set up event handler to detect text selection changes
 * @param callback Function to call when selection changes, receiving selected text
 */
export async function setupSelectionChangeListener(callback: (selectedText: string) => void): Promise<void> {
  try {
    Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, async () => {
      try {
        const selectedText = await getSelectedText();
        callback(selectedText);
      } catch (error) {
        console.error("Error handling document selection change:", error);
      }
    });
    console.log("Document selection change listener initialized successfully");
  } catch (error) {
    console.error("Error initializing document selection change listener:", error);
  }
}
